import { RSSButton } from "./RSSButton";

export const Subscribe = () => {
  return (
    <>
      <form
        action="https://johnok.us17.list-manage.com/subscribe/post?u=062fcd140aaf62b5c7b4cde9f&amp;id=9804bf0911"
        method="post"
        id="mc-embedded-subscribe-form"
        name="mc-embedded-subscribe-form"
        target="_blank"
        noValidate
      >
        <h2 className="text-xl font-bold line leading-8">
          Subscribe <RSSButton />
        </h2>
        <div className="text-lg font-bold line leading-10 mb-1">
          Join my mailing list
        </div>
        <input
          type="email"
          name="EMAIL"
          id="mce-EMAIL"
          className="shadow appearance-none border rounded w-64 mr-4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        />
        <div id="mce-responses">
          <div id="mce-error-response" style={{ display: "none" }}></div>
          <div id="mce-success-response" style={{ display: "none" }}></div>
        </div>
        <div
          style={{ position: "absolute", left: "-5000px" }}
          aria-hidden="true"
        >
          <input
            type="text"
            name="b_062fcd140aaf62b5c7b4cde9f_9804bf0911"
            tabIndex={-1}
            defaultValue=""
          />
        </div>
        <input
          type="submit"
          value="Subscribe"
          name="subscribe"
          id="mc-embedded-subscribe"
          className="hover:shadow-lg font-bold py-2 px-4 rounded-md shadow-md text-white bg-blue-500 hover:bg-blue-600 mt-4 cursor-pointer"
          readOnly
        />
      </form>
    </>
  );
};
